<dl class="saud">
  @if (level()) {
    <div class="saud__row">
      <dt><i class="fa-solid fa-layer-group"></i> {{ 'DATA_TABLE.LEVEL' | translate }}</dt>
      <dd>{{ level() }}</dd>
    </div>
  }
  @if (subject()) {
    <div class="saud__row">
      <dt><i class="fa-solid fa-book"></i> {{ 'CALENDAR.FILTER.SUBJECT' | translate }}</dt>
      <dd>{{ subject() }}</dd>
    </div>
  }
  @if (session().groupName) {
    <div class="saud__row">
      <dt><i class="fa-solid fa-users"></i> {{ 'CALENDAR.FILTER.GROUP' | translate }}</dt>
      <dd>{{ session().groupName }}</dd>
    </div>
  }
  @if (students().length) {
    <div class="saud__row">
      <dt>
        <i class="fa-solid fa-user-group"></i>
        {{ 'INSPECTION.CALENDAR.ATTENDEES' | translate:{ count: students().length } }}
      </dt>
      <dd class="saud__students">
        @for (st of students(); track st.studentId) {
          <span class="saud__student">{{ st.fullName }}</span>
        }
      </dd>
    </div>
  }
</dl>
